import { render, staticRenderFns } from "./ChooseInvoiceOrder.vue?vue&type=template&id=54225ab2&scoped=true&"
import script from "./ChooseInvoiceOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseInvoiceOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseInvoiceOrder.vue?vue&type=style&index=0&id=54225ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54225ab2",
  null
  
)

export default component.exports